<ion-img [src]="img?.url ?? FALLBACK_IMG_URL" [style.width]="img?.width + '%'" [style.height]="img?.height + '%'"
    (ionError)="onImgError($event)" [style.object-fit]="'contain'" [style]="img?.style"></ion-img>
